import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// Modules
import app from "./modules/app";
import home from "./modules/home";
import coupons from "./modules/coupons";
import topCoupons from "./modules/topCoupons";
import shops from "./modules/shops";
import products from "./modules/products";

const Store = new Vuex.Store({
  getters: {
    get() {}
  },
  modules: {
    app,
    home,
    coupons,
    topCoupons,
    shops,
    products
  }
});

export default Store;
